module.exports = "/images/tornado@3x.png?f52774973ae0690eacd53a4d1ce394e1";